import React, { FC, ReactNode, useRef } from 'react'
import cn from 'classnames'
import classNames from 'classnames'
import _Switch from 'rc-switch'

type Checkbox = {
  label?: ReactNode
  className?: string
  disabled?: boolean
  checked: boolean
  onChange: (newValue: boolean) => void
  id?: string
}
const Checkbox: FC<Checkbox> = ({
  checked,
  className,
  id,
  label,
  onChange,
  ...rest
}) => {
  const ref = useRef<HTMLInputElement>()
  return (
    <div className={cn('lh-input d-flex align-items-center', className)}>
      <_Switch
        {...rest}
        id={id}
        checked={checked}
        onChange={(e) => {
          ref.current?.blur()
          onChange(e)
        }}
      />
      <label
        onClick={() => {
          ref.current?.blur()
          onChange(!checked)
        }}
        className={classNames(
          'ms-2 cursor-pointer fw-semibold user-select-none form-check-label',
          {
            disabled: rest.disabled,
          },
        )}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  )
}

Checkbox.displayName = 'Checkbox'
export default Checkbox
